import * as React from 'react';
import pc from './overlay-icons/icon-pc.svg';
import deviceSong from './overlay-icons/device-song.svg';
import loop from './overlay-icons/icon-loop.svg';
import itunes from './overlay-icons/icon-itunes.svg';
import day from './overlay-icons/day.svg';
import month from './overlay-icons/month.svg';
import year from './overlay-icons/year.svg';
import image from './overlay-icons/image.svg';
import gif from './overlay-icons/gif.svg';
import video from './overlay-icons/video.svg';
import search from './overlay-icons/lens.svg';
import computer from './overlay-icons/computer.svg';
import device from './overlay-icons/icon-device.svg';
import free from './overlay-icons/free.svg';
import { generateClassName } from '../utils';
import { OverlayIcon } from './OverlayIcon';
import { useMobileLayout } from 'hooks/useMobileLayout';

export const computerIconUrl: string = computer;
export const imageIconUrl: string = image;

const Icons = {
  loop,
  pc,
  deviceSong,
  itunes,
  free,
  day,
  month,
  year,
  image,
  gif,
  video,
  search,
  computer,
  device
};

export interface OverlayOption {
  key:
    | 'loop'
    | 'pc'
    | 'deviceSong'
    | 'itunes'
    | 'free'
    | 'day'
    | 'month'
    | 'year'
    | 'image'
    | 'gif'
    | 'video'
    | 'search'
    | 'computer'
    | 'device';
  title: string;
  description?: string | React.ReactElement;
  cta: string;
  planDetails?: React.ReactElement;
  footer?: React.ReactElement | string;
  disabled?: boolean;
  bannerUrl?: string;
}

interface Props {
  items: OverlayOption[];
  onSelect: (key: string) => void;
}

export const OverlayOptions: React.FunctionComponent<Props> = props => {
  const { items, onSelect } = props;
  const hasAtLeastOneFooter =
    items.filter(i => i.footer !== undefined).length > 0;
  const isMobile = useMobileLayout();

  return (
    <div className="overlay-options">
      <>
        {items.map(item => {
          const key = item.key;
          const iconUrl = Icons[key];
          return (
            <div
              className={generateClassName('overlay-option', {
                disabled: item.disabled
              })}
              key={key}
              onClick={e => {
                if (
                  (e.target as HTMLElement).className.indexOf('rc-switch') > -1
                ) {
                  return;
                }
                onSelect(key);
              }}
            >
              <OverlayIcon imageUrl={iconUrl} />
              <h3>{item.title}</h3>
              {item.description && (
                <p
                  className={
                    'overlay-option-description' +
                    (item.planDetails
                      ? ' overlay-option-description--divider'
                      : '')
                  }
                >
                  {item.description}
                </p>
              )}
              {item.planDetails}
              <button className="large primary">{item.cta}</button>
              {isMobile
                ? item.footer && <p className="footer">{item.footer}</p>
                : hasAtLeastOneFooter && (
                    <p className="footer">{item.footer || '\u00A0'}</p>
                  )}
              {item.bannerUrl && (
                <img className="overlay-option-banner" src={item.bannerUrl} />
              )}
            </div>
          );
        })}
      </>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/OverlayOptions.tsx